import * as React from 'react';
import { useTranslation } from "react-i18next";
import { TextArea } from '@progress/kendo-react-inputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { FloatingLabel } from '@progress/kendo-react-labels';
import { Button } from '@progress/kendo-react-buttons';
import { DatePicker } from '@progress/kendo-react-dateinputs';
export default function OrdersCreateComponents() {
    const { t } = useTranslation();

    const [integrador, setIntegrador] = React.useState('');
    const [value, setValue] = React.useState(new Date());
    const changeDate = ({ value }) => {
        setValue(value);
    };
    const Integradores = [
        'Baseball',
        'Basketball',
        'Volleyball'
    ];

    return (
        <div>

            <div className="container-fluid">
                <div className="col-12 col-lg-11 mx-auto">
                    <div className="card">
                        <div className="card-body bg-light py-3">
                            <h5 className="card-title m-0">{t("Global_Label_Text_General")}</h5>
                        </div>


                        <div className="container p-4">
                            <div className="row g-3"> {/* g-3 añade espacio entre columnas y filas */}

                                <div className="col-12 col-md-3">
                                    <FloatingLabel label={t("Global_Label_Text_Integrator")} editorId="integrador" editorValue={integrador}>
                                        <DropDownList
                                            id="integrador"
                                            data={Integradores}
                                            value={integrador}
                                            onChange={(e) => setIntegrador(e.target.value)}
                                        />
                                    </FloatingLabel>
                                </div>
                                <div className="col-12 col-md-3">
                                    <FloatingLabel label={t("Global_Label_Text_Farms")} editorId="papel" editorValue={integrador}>
                                        <DropDownList
                                            id="papel"
                                            data={Integradores}
                                            value={integrador}
                                            onChange={(e) => setIntegrador(e.target.value)}
                                        />
                                    </FloatingLabel>
                                </div>

                                <div className="col-12 col-md-3">
                                    <DatePicker
                                        label={t("Global_Label_Text_Creation_Date")}
                                        value={value}
                                        onChange={changeDate}
                                        width={210}
                                    />
                                </div>
                                <div className="col-12 col-md-3">
                                    <DatePicker
                                        label={t("Global_Label_Text_Expected_Date")}
                                        value={value}
                                        onChange={changeDate}
                                        width={210}
                                    />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="container-fluid mt-4">
                <div className="col-12 col-lg-11 mx-auto">
                    <div className="card">
                        <div className="card-body bg-light py-3">
                            <h5 className="card-title m-0">{t("Global_Label_Text_Remarks")}</h5>
                        </div>

                        <div className="container p-3 p-md-4">
                            <div className="row g-3 mb-3 mb-md-4">
                                <TextArea
                                    label={t("Global_Label_Text_Remarks")}
                                    rows={4}
                                    style={{ width: "100%" }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            <div className="container-fluid mt-4">
                <div className="col-12 col-lg-11 mx-auto">
                    <div className="d-flex justify-content-end mb-3">
                        <Button className="action-button me-lg-11">{t("Global_Label_Text_Save")}</Button>
                    </div>
                </div>
            </div>



        </div>


    );
}